<template>
  <div class="hidden border-b border-b-grey-lighter bg-white widescreen:block">
    <VuepalAdminToolbar v-if="!isEditing" :key="language" />
    <div
      v-if="!isEditing"
      class="mx-auto flex h-20 items-center justify-between gap-4 bg-white px-4 text-black"
    >
      <VuepalLocalTasks class="mr-auto" />

      <div v-if="prodLink" class="text-size-6">
        <a :href="prodLink" target="_blank" class="link">Open on Production</a>
      </div>

      <div v-if="features.length" class="relative">
        <button @click="showFeatures = !showFeatures">New Features</button>
        <div
          v-if="showFeatures"
          class="absolute top-full right-0 z-[999999] bg-white p-4 shadow-xl"
        >
          <div v-for="feature in features" :key="feature.id">
            <label class="checkbox">
              <input
                type="checkbox"
                :checked="feature.enabled"
                @change="toggleOverride(feature.id)"
              />
              <span class="font-bold whitespace-nowrap !text-black">{{
                feature.label
              }}</span>
            </label>
          </div>
        </div>
      </div>
    </div>

    <AdminBarDomains />

    <Teleport to="body">
      <div
        v-if="showGrid && !isEditing"
        class="pointer-events-none fixed top-0 left-0 z-[9999999999] h-screen w-full"
      >
        <div class="container grid h-full grid-cols-12 gap-4">
          <div v-for="n in 12" :key="n" class="h-full bg-danger/15" />
        </div>
      </div>
    </Teleport>
  </div>
</template>

<script setup lang="ts">
import { DomainId } from '#graphql-operations'
import { onKeyStroke, useLocalStorage } from '@vueuse/core'

defineProps<{
  isEditing: boolean
}>()

const language = useCurrentLanguage()

const route = useRoute()
const { activeDomain } = useSiteContext()
const { features, toggleOverride } = useFeatureFlag()

const showFeatures = ref(false)
const showGrid = useLocalStorage('showGrid', () => false)

const PROD_HOSTS: Partial<Record<DomainId, string>> = {
  [DomainId.zuerich_com]: 'https://www.zuerich.com',
  [DomainId.eyz]: 'https://www.eyz.swiss',
  [DomainId.rapperswil_zuerichsee_ch]: 'https://www.rapperswil-zuerichsee.ch',
  [DomainId.hoteljobs_zuerich_ch]: 'https://hoteljobs.zuerich.com',
  [DomainId.zuerich_experience_com]: 'https://www.zuerich-experience.com',
}

const prodLink = computed(() => {
  const host = PROD_HOSTS[activeDomain]
  if (host) {
    return host + route.path
  }

  return null
})

onKeyStroke(['g'], (e) => {
  if (!e.ctrlKey) {
    return
  }
  e.preventDefault()
  showGrid.value = !showGrid.value
})
</script>
